<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 style="color:white;">Enclosed Area Attachments</h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
    class="mat-elevation-z8">

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header  style="align-items: center; text-align: center;">File Name</th>
      <td mat-cell *matCellDef="let attachmentFile" style="align-items: center; text-align: center;">
        <a (click)="getFile(attachmentFile)" target="_blank">{{attachmentFile.name}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
      <td mat-cell *matCellDef="let attachmentFile">{{attachmentFile.staff}}</td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
      <td mat-cell *matCellDef="let attachmentFile">{{attachmentFile.date}}</td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let attachmentFile">
        <a (click)="delete(attachmentFile)" *ngIf="isAdmin"><mat-icon style="color: red;">delete</mat-icon></a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
  </table>
  <br/>
  <div style="padding-right: 20px;">
    <button mat-raised-button (click)="return()" style="padding-right: 20px;">
      Return
    </button>
  </div>
  </mat-card-content>

</mat-card>

<!-- 
<div class="modal fade" id="enclosedAreaModalFiles" tabindex="-1" role="dialog" aria-labelledby="enclosedAreaModalFilesLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title " id="enclosedAreaModalFilesLabel">Enclosed Area Attachments</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" id="enclosedAreaModalFilesBody">
              <table class="table table-striped">
                  <thead>
                      <tr>
                          <th>File Name</th>
                          <th>User</th>
                          <th>Date</th>
                          <th></th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr ng-repeat="enf in enclosedFilesSelected">

                          <td><a href="/Complaint/EnclosedAreaFile/{{enf.Id}}" target="_blank">{{enf.Name}}</a></td>
                          <td>{{enf.Staff}}</td>
                          <td>{{enf.Date}}</td>
                          <td>
                              @if (User.IsInRole(WEMS_Mgmt.Utilities.Security.AdminRole))
                              {
                                  <a class="text-danger" ng-click="pageControls.removeAttachment(enf.Id)"><span class="glyphicon glyphicon-trash"></span></a>
                              }
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>

          </div>
      </div>
  </div>
</div> -->